export * from './licenses-card.component';
export * from './licenses-card.service';
